'use strict';

exports.__esModule = true;
exports.CardBox = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  transition: transform ', ' ease,\n    box-shadow ', ' ease;\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: ', ';\n  }\n'], ['\n  cursor: pointer;\n  transition: transform ', ' ease,\n    box-shadow ', ' ease;\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  border: ', ';\n  border-radius: ', ';\n  box-shadow: ', ';\n  ', ';\n'], ['\n  background-color: ', ';\n  border: ', ';\n  border-radius: ', ';\n  box-shadow: ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// Primitiv-Bibliothek (2026-06): zentrales Flächen-/Karten-Primitiv.
// Kapselt NUR die Optik (Hintergrund + Radius + Elevation) — Layout (padding,
// width, position, media) bleibt beim Konsumenten via styled(Card). Token-
// Auflösung mit Fallback-Kette analog shared/components/Button/ButtonStyled.js.

var resolveRadius = function resolveRadius(_ref) {
  var theme = _ref.theme,
      radius = _ref.radius;

  switch (radius) {
    case 'none':
      return '0';
    case 'sm':
      return theme.radiusSm || theme.borderRadiusDefault;
    case 'lg':
      return theme.radiusLg || theme.borderRadiusDefault;
    case 'md':
    default:
      return theme.radiusMd || theme.borderRadiusDefault;
  }
};

// Fallbacks spiegeln die echten Token-Werte aus shared/styles/theme.js (greifen nur
// ohne vollstaendigen ThemeProvider) — vorher fielen sm/md/lg alle auf denselben
// Legacy-Schatten 0 3px 6px, was die Stufen nivelliert haette.
var resolveElevation = function resolveElevation(_ref2) {
  var theme = _ref2.theme,
      elevation = _ref2.elevation;

  switch (elevation) {
    case 'none':
      return 'none';
    case 'sm':
      return theme.elevationSm || '0 1px 3px rgba(16, 24, 40, 0.08)';
    case 'lg':
      return theme.elevationLg || '0 12px 28px rgba(16, 24, 40, 0.12)';
    case 'md':
    default:
      return theme.elevationMd || '0 4px 12px rgba(16, 24, 40, 0.10)';
  }
};

// surface = weiße Karte (Default). navy = secondary-Vollfläche (bleibt navy laut
// Scope-Entscheid). plain = KEIN eigener Hintergrund (transparent) — für Karten,
// deren Fläche von Children/Layout/Border gesetzt wird (z.B. CvSample: bg liegt
// in den Spalten-Children) oder die nur Border + Elevation tragen sollen.
var resolveBackground = function resolveBackground(_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;

  switch (variant) {
    case 'navy':
      return theme.secondary;
    case 'plain':
      return 'transparent';
    case 'surface':
    default:
      return theme.white;
  }
};

// bordered = 1px-Border in der konsolidierten neutralen Border-Quelle (borderColor,
// loest textColorD8 mit ab). Sonst 'none' (render-neutral fuer bestehende Karten).
var resolveBorder = function resolveBorder(_ref4) {
  var theme = _ref4.theme,
      bordered = _ref4.bordered;
  return bordered ? '1px solid ' + (theme.borderColor || theme.textColorD8) : 'none';
};

// interactive = klickbare Karte: cursor + Hover-Lift exakt wie ButtonStyled.getHoverStyle
// (translateY(-1px) + elevationMd). Statische Karten bleiben unangetastet (kein Lift).
// Der Focus-Ring kommt spaeter zentral aus dem Focus-Mixin (Welle 2) dazu.
// Hover-Lift: Schatten eine Stufe anheben, aber NIE unter die Resting-Elevation
// schrumpfen. Resting lg -> Hover lg (kein Schrumpfen); sonst -> elevationMd (deckt
// die haeufigen Faelle none/sm/md mit sichtbarem Lift ab). translateY traegt den Lift
// zusaetzlich. Vorbild ButtonStyled.getHoverStyle.
var interactiveStyles = (0, _styledComponents.css)(_templateObject, function (_ref5) {
  var theme = _ref5.theme;
  return theme.durationFast || '0.15s';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.durationFast || '0.15s';
}, function (_ref7) {
  var theme = _ref7.theme,
      elevation = _ref7.elevation;
  return elevation === 'lg' ? theme.elevationLg || '0 12px 28px rgba(16, 24, 40, 0.12)' : theme.elevationMd || '0 4px 12px rgba(16, 24, 40, 0.10)';
});

var CardBox = exports.CardBox = _styledComponents2.default.div(_templateObject2, resolveBackground, resolveBorder, resolveRadius, resolveElevation, function (_ref8) {
  var interactive = _ref8.interactive;
  return interactive && interactiveStyles;
});